module.exports = __webpack_public_path__ + "static/rainbowbath-f162a1b91d52ff528f77fd06ca7f7776.jpeg";